import { Component, Input } from '@angular/core'
import { NgClass } from '@angular/common';
import { ResponsiveComponent } from '@nx-superprep/shared'
import { PerformanceStats } from '@nx-superprep/backend/firebase';
@Component({
  selector: 'pop-ui-lesson-tile-completion',
  standalone: true,
  imports: [NgClass],
  templateUrl: './completion.component.html',
  styleUrls: ['./completion.component.scss'],
})
export class LessonTileCompletionComponent extends ResponsiveComponent {
  @Input() stats: PerformanceStats[] | undefined

  get retention() {
    const v = Number((this.stats??[]).find(s => s.name === 'retention')?.value) || 0
    return v >= 1 ? v.toFixed(0) + '%' : '-'
  }
  get streak() {
    const v = Number((this.stats??[]).find(s => s.name === 'streak')?.value) || 0
    return v > 0 ? v.toFixed(0) : '-'
  }
  get completed() {
    const v = Number((this.stats??[]).find(s => s.name === 'completed')?.value) || 0
    return v >= 1 ? v.toFixed(0) + '%' : '-'
  }
}
